import { useSourcingExternalStore } from 'modules/sourcing-external/stores';
import { useShallow } from 'zustand/react/shallow';
import { SourcingSharedSetupApplicationStep } from 'modules/sourcing-shared/shared-steps';
import { getSourcingExternalHeaderBreadcrumbs } from 'modules/sourcing-external/utils';
import { Channels } from 'generated-graphql/types';

export const SourcingExternalSetupApplicationStep = () => {
  const {
    candidateBatch,
    applicationFormData,
    channelFormData,
    onSetupApplicationBack,
    onSetupApplicationNext,
    setStep
  } = useSourcingExternalStore(
    useShallow((state) => ({
      candidateBatch: state.candidateBatch,
      applicationFormData: state.applicationFormData,
      channelFormData: state.channelFormData,
      onSetupApplicationBack: state.onSetupApplicationBack,
      onSetupApplicationNext: state.onSetupApplicationNext,
      setStep: state.setStep
    }))
  );

  // This shouldn't happen
  if (!candidateBatch) return null;

  return (
    <SourcingSharedSetupApplicationStep
      headerBreadcrumbs={getSourcingExternalHeaderBreadcrumbs({
        candidateBatchJobTitle:
          candidateBatch.jobDescriptionParsed?.jobTitle ?? '',
        candidateBatchId: candidateBatch.id,
        setStep
      })}
      candidateBatchId={candidateBatch.id}
      hasCandidateBatchAtsJobId={!!candidateBatch.atsJobId}
      candidateBatchAtsJobPostingUrl={candidateBatch.atsJobPostingUrl}
      candidateBatchCustomJobPostingUrl={candidateBatch.customJobPostingUrl}
      defaultFormData={applicationFormData}
      channelType={channelFormData?.channel ?? Channels.Email}
      onSetupApplicationBack={onSetupApplicationBack}
      onSetupApplicationNext={onSetupApplicationNext}
    />
  );
};
